/**
 * Community Asset API functions.
 *
 * Maps to backend scenario-service endpoints:
 *   POST   /api/communities/:cid/assets          - Create community asset
 *   GET    /api/communities/:cid/assets          - List community assets
 *   PUT    /api/communities/:cid/assets/:aid     - Update community asset
 *   DELETE /api/communities/:cid/assets/:aid     - Delete community asset
 */

import client from './client';

/**
 * List all community-level assets.
 * @param {string} communityId - UUID
 * @returns {Promise<Array>}
 */
export const getAssets = async (communityId) => {
  return client.get(`/api/communities/${communityId}/assets`);
};

/**
 * Create a community-level asset (solar_pv_farm, wind_turbine, community_battery).
 * @param {string} communityId - UUID
 * @param {Object} data - { name, kind, asset_type, owner_scope, spec, specs, metadata }
 * @returns {Promise<Object>} Created asset
 */
export const createAsset = async (communityId, data) => {
  return client.post(`/api/communities/${communityId}/assets`, data);
};

/**
 * Update a community-level asset (partial).
 * @param {string} communityId - UUID
 * @param {string} assetId - UUID
 * @param {Object} data - Fields to update
 * @returns {Promise<Object>} Updated asset
 */
export const updateAsset = async (communityId, assetId, data) => {
  return client.put(`/api/communities/${communityId}/assets/${assetId}`, data);
};

/**
 * Delete a community-level asset.
 * @param {string} communityId - UUID
 * @param {string} assetId - UUID
 * @returns {Promise<void>}
 */
export const deleteAsset = async (communityId, assetId) => {
  return client.delete(`/api/communities/${communityId}/assets/${assetId}`);
};
